import ObjectBuilderInterface from "@/modules/api/object-builder.interface";

import AttachmentFactory from "./attachment.factory";
import Attachment from "./attachment.model";
import CreateMessageResponse from "./create-message-response.interface";
import MessageFactory from "./message.factory";

export default class CreateMessageResponseFactory
  implements ObjectBuilderInterface<CreateMessageResponse> {
  constructor(
    private fMessageFactory: MessageFactory,
    private fAttachmentFactory: AttachmentFactory
  ) {}

  public buildFromJSON(data: Record<string, unknown>): CreateMessageResponse {
    const message = this.fMessageFactory.buildFromJSON(data);

    let attachments: Attachment[] = [];

    if (Array.isArray(data.attachments)) {
      attachments = data.attachments.map((attachmentData) =>
        this.fAttachmentFactory.buildFromJSON(
          attachmentData as Record<string, unknown>
        )
      );
    }
    return {
      message,
      attachments,
    };
  }
}
